// extracted by mini-css-extract-plugin
export var settingsList = "_2w-0";
export var settingsRow = "_2w-1";
export var warningDot = "_2w-2";